/**
 * Cart drawer socks filler + set upsell (GR task 1.17)
 *
 * Both elements read /cart.js each time the theme reports a cart change, so they stay
 * correct without the theme re-rendering them. Adds go through the drawer's <cart-items>.
 * GA4 events: cart_filler_view / cart_filler_add, cart_set_upsell_view / cart_set_upsell_add.
 */
(function () {
  if (window.__cartUpsellLoaded) return;
  window.__cartUpsellLoaded = true;

  var SET_STYLES = {
    top: ['wilder', 'caswell'],
    pants: ['bodie', 'pfeiffer', 'hatton'],
  };
  // Same pairing order as "Complete the set" on the product page
  var PARTNER_ORDER = {
    top: ['bodie', 'pfeiffer', 'hatton'],
    pants: ['wilder', 'caswell'],
  };

  var seenViews = {};
  var productCache = {};

  // GA4 event via the gtag already on the page (respects consent mode)
  function track(name, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({event: name}, params));
      }
    } catch (error) {
      // Tracking must never break the page
    }
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2);
    }
  }

  function sized(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function getCart() {
    return fetch('/cart.js', {headers: {Accept: 'application/json'}}).then(function (response) {
      return response.json();
    });
  }

  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js', {headers: {Accept: 'application/json'}})
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .catch(function () {
          return null;
        });
    }
    return productCache[handle];
  }

  function optionIndex(product, name) {
    var options = product.options || [];
    for (var i = 0; i < options.length; i++) {
      var optionName = typeof options[i] === 'string' ? options[i] : options[i].name;
      if (String(optionName).toLowerCase() === name) return i;
    }
    return -1;
  }

  function lineOption(item, name) {
    var options = item.options_with_values || [];
    for (var i = 0; i < options.length; i++) {
      if (String(options[i].name).toLowerCase() === name) return options[i].value;
    }
    return null;
  }

  function addItems(items, button) {
    var cartItems = document.querySelector('cart-items');
    if (button) button.disabled = true;

    var restore = window.setTimeout(function () {
      if (button) button.disabled = false;
    }, 4000);

    if (cartItems && typeof cartItems.addToCart === 'function') {
      cartItems.addToCart(items, button);
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({items: items}),
    })
      .then(function () {
        window.clearTimeout(restore);
        window.location.reload();
      })
      .catch(function () {
        if (button) button.disabled = false;
      });
  }

  class CartBlock extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.body = this.querySelector('[data-cu-body]');
      this.timer = null;
      this.token = 0;

      var schedule = this.schedule.bind(this);
      document.addEventListener('theme:cart:change', schedule);
      document.addEventListener('theme:cart-drawer:open', schedule);
      document.addEventListener('theme:product:added', schedule);
      this.init();
      this.schedule();
    }

    init() {}

    schedule() {
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(this.refresh.bind(this), 150);
    }

    refresh() {
      var token = ++this.token;
      getCart().then(
        function (cart) {
          if (token === this.token) this.update(cart);
        }.bind(this)
      );
    }

    show(visible) {
      this.hidden = !visible;
      if (!visible && this.body) this.body.textContent = '';
    }

    view(name, key, params) {
      if (seenViews[key]) return;
      seenViews[key] = true;
      track(name, params);
    }
  }

  class CartShipFiller extends CartBlock {
    init() {
      try {
        this.socks = JSON.parse(this.querySelector('[data-cu-socks]').textContent);
      } catch (error) {
        this.socks = [];
      }
    }

    limitCents() {
      var bar = document.querySelector('[data-free-shipping-limit]');
      var limit = Number((bar && bar.getAttribute('data-free-shipping-limit')) || this.dataset.limit);
      var rate = (window.Shopify && window.Shopify.currency && Number(window.Shopify.currency.rate)) || 1;
      return limit * 100 * rate;
    }

    update(cart) {
      var gap = this.limitCents() - cart.total_price;
      if (!cart.item_count || !(gap > 0) || !this.socks.length) return this.show(false);

      var inCart = {};
      cart.items.forEach(function (item) {
        inCart[item.variant_id] = true;
      });

      // One pair has to be enough to unlock free shipping
      var pick = this.socks.filter(function (socks) {
        return !inCart[socks.id] && socks.price >= gap;
      })[0];
      if (!pick) return this.show(false);

      this.body.textContent = '';
      if (pick.image) {
        var image = el('img', 'cart-upsell__image');
        image.src = pick.image;
        image.alt = '';
        image.width = 56;
        image.height = 70;
        image.loading = 'lazy';
        this.body.appendChild(image);
      }

      var info = el('div', 'cart-upsell__info');
      info.appendChild(el('span', 'cart-upsell__name', 'Add ' + pick.title + ' for free shipping'));
      info.appendChild(el('span', 'cart-upsell__meta', money(gap) + ' to go'));
      this.body.appendChild(info);

      var button = el('button', 'cart-upsell__add', 'Add · ' + money(pick.price));
      button.type = 'button';
      button.addEventListener('click', function () {
        track('cart_filler_add', {filler_product: pick.title, value: pick.price / 100, currency: 'USD'});
        addItems([{id: pick.id, quantity: 1, properties: {_source: 'cart-ship-filler'}}], button);
      });
      this.body.appendChild(button);

      this.show(true);
      this.view('cart_filler_view', 'filler|' + pick.id, {filler_product: pick.title, filler_gap: Math.round(gap) / 100});
    }
  }

  class CartSetUpsell extends CartBlock {
    init() {
      this.titleNode = this.querySelector('[data-cu-title]');
      this.heading = this.dataset.heading || 'Complete your set';
    }

    // The first top-or-pants line decides which half of the set is missing
    findAnchor(cart) {
      var tops = [];
      var pants = [];
      cart.items.forEach(function (item) {
        var type = String(item.product_type || '').toLowerCase();
        if (type.indexOf('top') > -1) tops.push(item);
        else if (type.indexOf('pant') > -1) pants.push(item);
      });
      if (tops.length && !pants.length) return {role: 'top', item: tops[0]};
      if (pants.length && !tops.length) return {role: 'pants', item: pants[0]};
      return null;
    }

    update(cart) {
      var anchor = this.findAnchor(cart);
      if (!anchor) return this.show(false);

      var match = /^the-([a-z]+)-(.+)$/.exec(anchor.item.handle || '');
      var size = lineOption(anchor.item, 'size');
      if (!match || !size || SET_STYLES[anchor.role].indexOf(match[1]) === -1) return this.show(false);

      var color = match[2];
      var styles = PARTNER_ORDER[anchor.role];
      var token = this.token;

      Promise.all(
        styles.map(function (style) {
          return getProduct('the-' + style + '-' + color);
        })
      ).then(
        function (products) {
          if (token !== this.token) return;

          for (var i = 0; i < products.length; i++) {
            var product = products[i];
            if (!product) continue;

            var sizeIndex = optionIndex(product, 'size');
            var lengthIndex = optionIndex(product, 'length');
            var variant = null;
            for (var v = 0; v < product.variants.length; v++) {
              var candidate = product.variants[v];
              if (!candidate.available) continue;
              if (sizeIndex < 0 || candidate.options[sizeIndex] !== size) continue;
              // Never default to Tall: Regular vs Tall mix-ups are a top return reason
              if (lengthIndex > -1 && candidate.options[lengthIndex] !== 'Regular') continue;
              variant = candidate;
              break;
            }
            if (variant) return this.render(anchor, styles[i], product, variant, size);
          }

          this.show(false);
        }.bind(this)
      );
    }

    render(anchor, style, product, variant, size) {
      this.titleNode.textContent = this.heading;
      this.body.textContent = '';

      var image = el('img', 'cart-upsell__image');
      image.src = sized(product.featured_image, 160);
      image.alt = '';
      image.width = 56;
      image.height = 70;
      image.loading = 'lazy';
      this.body.appendChild(image);

      var info = el('div', 'cart-upsell__info');
      var name = el('a', 'cart-upsell__name', product.title);
      name.href = '/products/' + product.handle;
      info.appendChild(name);
      var lengthIndex = optionIndex(product, 'length');
      var meta = 'Size ' + size + (lengthIndex > -1 ? ' / ' + variant.options[lengthIndex] : '');
      info.appendChild(el('span', 'cart-upsell__meta', meta));
      this.body.appendChild(info);

      var button = el('button', 'cart-upsell__add', 'Add · ' + money(variant.price));
      button.type = 'button';
      button.addEventListener('click', function () {
        track('cart_set_upsell_add', {set_role: anchor.role, set_partner: style, set_size: size, value: variant.price / 100, currency: 'USD'});
        addItems([{id: variant.id, quantity: 1, properties: {_source: 'cart-set-upsell'}}], button);
      });
      this.body.appendChild(button);

      this.show(true);
      this.view('cart_set_upsell_view', 'set|' + style + '|' + size, {set_role: anchor.role, set_partner: style, set_size: size});
    }
  }

  if (!customElements.get('cart-ship-filler')) customElements.define('cart-ship-filler', CartShipFiller);
  if (!customElements.get('cart-set-upsell')) customElements.define('cart-set-upsell', CartSetUpsell);
})();
